<template>
  <v-card
    v-if="quotation != null"
    color="white"
    flat
    class="platform-font full-screen-view"
  >
    <v-row justify="end">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            class="font-weight-bold"
            text
            color="primary"
            @click="downloadPDF"
          >
            <v-icon class="mr-1">mdi-download</v-icon>Download as PDF
          </v-btn>
        </template>
        Download PDF file for printing
      </v-tooltip>
    </v-row>
    <vue-headful :title="getQuotationTitle()" />
    <quotation-overview
      :quotation="quotation"
      v-if="quotation != null"
    ></quotation-overview>

    <v-card-actions class="pb-4 pt-0 mt-0">
      <v-row justify="end">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              class="font-weight-bold"
              text
              color="primary"
              @click="downloadPDF"
            >
              <v-icon class="mr-1">mdi-download</v-icon>Download as PDF
            </v-btn>
          </template>
          Download PDF file for printing
        </v-tooltip>
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
import axios from "axios";
import constant from "../../const";

export default {
  data() {
    return {
      quotation: null,
      id: null,
    };
  },

  async created() {
    // verify user token
    await this.$root.verify_user_token();

    this.$root.fullScreenView = true;
    this.id = this.$route.query.id;
  },

  mounted() {
    this.id = this.$route.query.id;
    this.$root.blockUIshow = true;
    this.$root.blockUImsg = "Loading quotation details";
    var response = null;

    this.$https
      .get("/api/quotations/" + this.id)
      .then((resp) => (response = resp.data))
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        if (response.status == constant.RESPONSE_STATUS_OK) {
          this.quotation = response.data;
        } else {
          console.log(response);
        }

        this.$root.blockUIshow = false;
      });
  },

  methods: {
    getQuotationTitle() {
      // var quotationIDLabel = this.quotation.quotation_id != null ? this.quotation.quotation_id : 'DRAFT'

      return (
        this.quotation.quotation_id +
        " " +
        this.quotation.transaction_type +
        " " +
        this.quotation.container_load +
        " " +
        this.quotation.incoterm.incoterm +
        " " +
        this.quotation.cargo_type.code +
        " " +
        this.quotation.origin_port.name +
        " to " +
        this.quotation.destination_port.name
      );
    },

    /** Get the quotation title to represent the file name */
    getTitleFilename() {
      var quotationIDLabel =
        this.quotation.quotation_id != null ? this.quotation.quotation_id : "DRAFT";

      return (
        quotationIDLabel +
        " " +
        this.quotation.transaction_type +
        " " +
        this.quotation.container_load +
        " " +
        this.quotation.incoterm.incoterm +
        " " +
        this.quotation.cargo_type.code +
        " " +
        this.quotation.origin_port.un_code +
        " to " +
        this.quotation.destination_port.un_code
      );
    },

    /** Download as a pdf file */
    downloadPDF() {
      this.$root.blockUImsg = "Downloading quotation file...";
      this.$root.blockUIshow = true;

      // package the url link
      var url_link = `${constant.HOSTNAME}/print-quotation-overview?id=${this.quotation.quotation_id}`;

      // let url = `https://asia-northeast1-cloud-accele-freight.cloudfunctions.net/generatePDF?url_link=${url_link}&fn=${this.getTitleFilename()}&token=${encodeURIComponent(
      //   this.$root.access_token
      // )}`;
      let url = `https://asia-northeast1-cloud-accele-freight.cloudfunctions.net/generatePDF?url_link=${url_link}&fn=${this.getTitleFilename()}`;

      axios
        .get(url, {
          responseType: "blob",
        })
        .then((resp) => {
          var fileURL = URL.createObjectURL(resp.data);
          var fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.download = `${this.getTitleFilename()}.pdf`;
          fileLink.click();

          // revoke the file url to clear up memory
          setTimeout(function () {
            // For Firefox it is necessary to delay revoking the ObjectURL
            URL.revokeObjectURL(fileURL);
          }, 100);

          this.showSnackbar = true;
          this.snackbarColor = "success";
          this.snackbarMsg = "Quotation successfully downloaded";
        })
        .catch((err) => {
          console.log(err);
          this.showSnackbar = true;
          this.snackbarColor = "error";
          this.snackbarMsg = err;
          this.$root.blockUIshow = false;
        })
        .finally(() => {
          this.$root.blockUIshow = false;
        });
    },
  },
};
</script>

<style></style>
